(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('headend-manage-pricing', {
            parent: 'astbmso-main.headend',
            url: '/headend-manage-pricing',
            data: {
                authorities: ['Administrators', 'Billing Administrator']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/astb/headend/headend-manage-pricing-dialog.html',
                    controller: 'HeadendManagePricingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                boxFeeMot: null,
                                boxFeeNonMot: null,
                                dtaFee: null,
                                applyTo: 'ALL',
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('astbmso-main.headend', null, { reload: 'astbmso-main.headend' });
                }, function() {
                    $state.go('astbmso-main.headend');
                });
            }]
        })
        
    }

})();
